export const COMPANY_STATISTICS_TITLES = [
  "countriesSupported",
  "countriesSupportingPayPal",
  "countriesSupportingGiftCards",
  "countriesSupportingCharity",
  "customersCount",
  "fundsDelivered",
  "giftCardOptions",
  "payoutOptions",
  "numberOfPayoutsSent",
  "teamMembers",
  "minVolumeForDiscount",
] as const
